import { ExpandableTable } from "../../../../components/UniversalTable";
import { documentTypeTableColumns } from "../../../../helpers";
import { PaystubItem } from "../../../../types/verified/paystub";
import { useMemo } from "react";
import { ExpandedTableRow } from "./slices/ExpandedTableRow";

export const PaystubTable = ({
  incomeItems
}: {
  incomeItems?: PaystubItem[];
}) => {
  const { flatPaystubs, flatWarnings } = useMemo(
    () => ({
      flatPaystubs:
        incomeItems?.flatMap((i) =>
          i.data?.document?.income_sources?.flatMap(
            (incSource) => incSource.pay_stubs
          )
        ) ?? [],
      flatWarnings:
        incomeItems?.flatMap((i) => i.data?.document?.warnings) ?? []
    }),
    [incomeItems]
  );

  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300 font-medium"
      renderExpanded={(row) => {
        return (
          <div className="px-6 py-8 bg-background-900">
            <ExpandedTableRow rowData={row} />
          </div>
        );
      }}
      rows={[...flatWarnings, ...flatPaystubs]}
      columns={documentTypeTableColumns}
    />
  );
};
